// extracted by mini-css-extract-plugin
export default {"wrapper":"LogoAnimation_wrapper__RQwdM","logoMobile":"LogoAnimation_logoMobile__+sakZ","logoTelegivCom":"LogoAnimation_logoTelegivCom__kmDvR"};